import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';
import { Map as ImmutableMap } from 'immutable';

export const DIALOG_TYPE = 'EDIT_REMINDER_DIALOG';

type EditReminderDialogOptions = {
  rootModalDrawer?: RootModalDrawerOptions;
};

export const editReminderDialog = (txn: TransactionRecord, context: string, otherProps?: EditReminderDialogOptions) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      allowNesting: true,
      id: `EDIT_REMINDER_${txn?.id || '0'}`,
      props: ImmutableMap({
        txn,
        context,
        dialogId: `EDIT_REMINDER_${txn?.id || '0'}`,
        ...otherProps,
      }),
    }),
  );
